import { render } from "./FloatingCart.vue?vue&type=template&id=03cfd54c"
import script from "./FloatingCart.vue?vue&type=script&lang=js"
export * from "./FloatingCart.vue?vue&type=script&lang=js"

import "./FloatingCart.vue?vue&type=style&index=0&id=03cfd54c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__